import React, { useState } from 'react';
import { IMediaHubView } from "./type/media-hub.types";
import MediaFolders from "./component/media-folders/media-folders";
import { DatePicker, Input } from "antd";
import MediaCollection from "./component/media-collection/media-collection";
import PageHeader from "../common/page-header/page-header";
import { Search } from "lucide-react";
import { useDebounce } from "../../custom_hooks/useDebounce";


const MediaHubView: React.FC<IMediaHubView> = (props) => {

    const [searchTerm, setSearchTerm] = useState('');
    const debouncedValue = useDebounce<string>(searchTerm, 500);

    return (
        <div className={'media-hub-container'}>
            <PageHeader
                title={'Media Hub'}
                description={'Browse, manage and share your organisation\'s visual memories'}
                actions={
                    <>
                        <Input
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                            }}
                            className={'media-hub-container__search-bar'}
                            prefix={<Search/>}
                            placeholder="Search events,images ...."
                        />

                        <ul className={'media-hub-container__category-list'}>
                            {props.tabs.map((tab: { label: string, path: string }, index: number) => {
                                    return (
                                        <li
                                            key={index}
                                            onClick={() => {
                                                props.handleTabChange(tab.path)
                                            }}
                                            className={`category-item ${props.categorySelected === tab.label ?
                                                'active' : ''}`}>
                                            {tab.label}
                                        </li>
                                    )
                                }
                            )}
                        </ul>
                        <DatePicker
                            value={props.date}
                            onChange={props.onYearChange}
                            picker={'year'}
                            className={'media-hub-container__datepicker'}
                        />
                    </>}
            />

            <section className={'media-hub-container__content-section'}>
                {props.showFolder ?
                    (
                        <MediaFolders
                            searchTerm={debouncedValue}
                            categorySelected={props.categorySelected}
                            date={props.date}
                        />
                    )
                    : (
                        <MediaCollection
                            searchTerm={debouncedValue}
                        />
                    )}

            </section>

        </div>
    )
}

export default MediaHubView;
